module.exports = __webpack_public_path__ + "static/media/ic_add_white.28434bb3.svg";